import React from 'react';
import { Skeleton } from '@/app/components/ui/Skeleton';
import { cn } from '@/app/lib/utils';

type PlanBalanceCardSkeletonProps = {
  className?: string;
};

export default function PlanBalanceCardSkeleton({ className }: PlanBalanceCardSkeletonProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-2 rounded-lg border border-primary/40 bg-primary/10 px-4 py-2',
        className
      )}
    >
      <div className="flex items-center gap-2">
        <Skeleton className="h-3 w-20 rounded" />
        <Skeleton className="h-[22px] w-14 rounded-full" />
      </div>
      <div className="flex h-[18px] items-center gap-1.5">
        <Skeleton className="h-[18px] w-14 rounded" />
        <Skeleton className="h-3.5 w-24 rounded" />
      </div>
    </div>
  );
}
